<template>
  <div class="importStaffStepOne">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Thêm danh sách công việc từ file</h1>
      <div class="btn-group float-right">
        <router-link class="f12 font-medium btn btn-outline-secondary" :to="`/cat-calendar-afs`">
          <i class="bx bx-arrow-back"></i> Quay lại
        </router-link>
      </div>
    </div>

    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body">
        <div class="step-content">
          <div class="step-upfile">
            <section class="open-input">
              <div class="oi-alert">
                <span v-show="keyCheckUpload === 0" style="width: 80px; display: inline-block"
                  ><img src="@/assets/img/upload.svg" alt=""
                /></span>
                <span v-show="keyCheckUpload === 1" style="width: 80px; display: inline-block"
                  ><img src="@/assets/img/upload-thanhcong.svg" alt=""
                /></span>
                <span v-show="keyCheckUpload === 2" style="width: 80px; display: inline-block"
                  ><img src="@/assets/img/upload-thatbai.svg" alt=""
                /></span>
              </div>

              <div class="input-file-container" style="width: 150px">
                <input
                  class="input-file"
                  style="display: none"
                  id="my-file"
                  @change="uploadFileExcel"
                  type="file"
                />
                <label tabindex="0" for="my-file" class="btn btn-outline-secondary"
                  >Chọn file tải lên</label
                >
              </div>
              <p v-if="this.messFailFormat != ''" style="color: red">
                {{ this.messFailFormat }}
              </p>
            </section>
            <p class="text-primary font-size-20 mb-3">{{ fileName }}</p>
            <p>Hỗ trợ các tệp có định dạng *.xls, *.xlsx, *.csv, *.ods</p>
            <button type="button" @click="downloadFileTemplateExcel()" class="btn">
              <i class="bx bx-archive-in"></i> Tải file mẫu
            </button>
          </div>

          <div class="step-upfooter">
            <button
              type="button"
              class="btn btn-primary btn-lg"
              style="width: 100%"
              @click="submitUpload()"
            >
              Xác nhận
            </button>
          </div>

          <div class="history-file table-responsive m-t-20">
            <h3 class="m-b-10">Lịch sử upfile</h3>
            <table class="table table-bordered table-hover">
              <thead>
                <tr>
                  <th>Thời gian</th>
                  <th>Tên file</th>
                  <th>Người upload</th>
                </tr>
              </thead>
              <tbody v-for="(item, index) in dataHistoryUpload" :key="index">
                <tr>
                  <td>{{ item.timeUpload | formatDate('HH:mm DD/MM/YYYY') }}</td>
                  <td>
                    <a href="#">{{ item.fileName }}</a>
                  </td>
                  <td>{{ item.userUpload }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showModalImportSuccess">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalImportSuccess = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img src="@/assets/img/noti-success2.svg" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ messSuccess }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="(showModalImportSuccess = false), closeImport()"
                    data-dismiss="modal"
                  >
                    Đồng ý
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div v-if="showModalErr">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalErr = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img src="@/assets/img/noti-unsuccess2.svg" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ messErr }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="showModalErr = false"
                    data-dismiss="modal"
                  >
                    Bỏ qua
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import readXlsxFile from 'read-excel-file'
  import { mapGetters } from 'vuex'
  import { CalendarAfsService } from '@/services/calendar-afs.service'

  export default {
    data() {
      return {
        messFailFormat: '',
        dataHistoryUpload: [],
        keyCheckUpload: 0,
        formData: null,
        headersTbRow: [],
        dataStaffExcel: [],
        dataErrorLine: [],
        fileName: null,
        showModalImportSuccess: false,
        messSuccess: '',
        showModalErr: false,
        messErr: '',
        showLoading: false,
      }
    },

    created() {
      this.getHistoryUpload()
    },

    methods: {
      async downloadFileTemplateExcel() {
        try {
          this.showLoading = true
          await CalendarAfsService.downloadTemplateCatCalendar()
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },

      async closeImport() {
        this.$router.push('/calendar-afs')
      },

      async getHistoryUpload() {
        const body = {
          size: 20,
          page: 1,
        }
        const dataResponse = await CalendarAfsService.historyImportCatCalendar(body)

        if (dataResponse.code === 1000) {
          this.dataHistoryUpload = dataResponse.data
        }
      },

      async uploadFileExcel(file) {
        const allowedExtensions = /(\.xls|\.xlsx|\.csv|\.ods)$/i
        const checkFomat = allowedExtensions.exec(file.target.files[0].name)

        const fileData = file.target.files[0]

        if (fileData.size > 20 * 1024 * 1024) {
          alert('File tối đa 20MB')
          return
        }

        this.fileName = fileData.name
        this.messFailFormat = ''
        this.keyCheckUpload = 1
        this.formData = new FormData()
        this.formData.append('file', fileData)
        this.formData.append('urlFile', file.target.files[0].name)
        this.parserDataExcelToJson(fileData)

        if (!checkFomat) {
          this.keyCheckUpload = 2
          this.messFailFormat = 'Định dạng không hợp lệ !'
          this.fileName = null
        }
      },

      async submitUpload() {
        try {
          this.showLoading = true

          if (this.formData === null) {
            this.messFailFormat = 'Vui lòng chọn file tải lên !'
          }

          const data = await CalendarAfsService.importCatCalendar(this.formData)

          await this.$store.dispatch('staff/cacheDataErrRowExcel', [])
          await this.$store.dispatch('staff/cacheFileNameExcel', this.fileName)

          if (data.code === 1000) {
            this.$router.push({ path: 'import-cat-calendar-success' })
          } else if (data.code === 1020 || data.code === 1007) {
            this.showModalErr = true
            this.messErr =
              'Thông tin trong file không đúng quy định hoặc dung lượng file quá lớn (tối đa 25MB)'
          } else if (data.code === 1021 || data.code === 1040) {
            await this.$store.dispatch('staff/cacheDataErrRowExcel', data.data)
            this.$router.push({ path: 'import-cat-calendar-err' })
          } else {
            this.showModalErr = true
            this.messErr = data.message
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },

      async parserDataExcelToJson(data) {
        this.dataStaffExcel = []
        this.$store.dispatch('staff/cacheDataRowExcel', [])

        readXlsxFile(data).then(rows => {
          this.headersTbRow = rows[0]

          for (let i = 2; i < rows.length; i++) {
            const element = rows[i]
            const body = {
              index: element[0],
              wkGroupId: element[1],
              taskName: element[2],
              taskCode: element[3],
              note: element[4],
              level: element[5],
              reviewTime: element[6],
              condition: element[7],
              point: element[8],
              is_error: false,
              descriptionValidate: '',
            }

            this.dataStaffExcel.push(body)
          }
          this.$store.dispatch('staff/cacheDataRowExcel', this.dataStaffExcel)
        })
      },
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
  }
</script>
